export const 
    BACKUPS_LOAD_REQ        = 'BACKUPS_LOAD_REQ',
    BACKUPS_LOAD_SUCCESS    = 'BACKUPS_LOAD_SUCCESS',
    BACKUPS_LOAD_ERROR      = 'BACKUPS_LOAD_ERROR'